// Copyright (C) 2021-Present CITEC Inc. <https://citecsolutions.com/>
// All rights reserved
//
// This file is part of CITEC Inc. source code.
// This software framework contains the confidential and proprietary information
// of CITEC Inc., its affiliates, and its licensors. Your use of these
// materials is governed by the terms of the Agreement between your organization
// and CITEC Inc., and any unauthorized use is forbidden. Except as otherwise
// stated in the Agreement, this software framework is for your internal use
// only and may only be shared outside your organization with the prior written
// permission of CITEC Inc.
// CITEC Inc. source code can not be copied and/or distributed without the express
// permission of CITEC Inc.

import { createApi } from '@reduxjs/toolkit/query/react';
import { fetchQuery } from '@shared/data-access/queries';
import { SHARED_TAG_TYPES } from '@shared/data-access/utils';
import { environment } from '@shared/environment';

/**
 * AI API configuration using Redux Toolkit Query.
 *
 * This API is used to interact with the Montecarlo, Portfolio, Reporting, Screener,
 * Trader, Asset Allocation, and Portfolio Multi-Asset endpoints.
 *
 * The API provides tags for caching and invalidation purposes, including Assets,
 * Montecarlo, Portfolio, Reporting, Screener, Trader, Asset Allocation, Portfolio
 * Multi-Asset, as well as shared tag types.
 */
export const aiApi = createApi({
  baseQuery: fetchQuery({
    baseUrl: environment.API.AI_BASE_URL,
    headers: {
      'Content-Type': environment.API_CONSTANTS.HEADERS.CONTENT_TYPE,
      accept: environment.API_CONSTANTS.HEADERS.ACCEPT,
      Authorization: `Bearer ${environment.AI.API_BEARER_TOKEN}`,
    },
    authTokenUsage: 'query-user',
  }),
  endpoints: () => ({}),
  reducerPath: 'citecAiApi',
  tagTypes: [
    'Assets',
    'Montecarlo',
    'Portfolio',
    'Reporting',
    'Screener',
    'Trader',
    'AssetAllocation',
    'PortfolioMultiAsset',
    ...SHARED_TAG_TYPES,
  ],
});
